import React, { FunctionComponent } from 'react';
import { currencyToNumber } from '../../../utils/formatting';

type InputType = 'text' | 'percentage' | 'number' | 'currency' | undefined;

interface InputProps {
    label?: string;
    name: string;
    defaultValue?: any;
    id: string;
    placeholder?: string;
    register: any;
    validation?: any;
    hasError?: any;
    type?: InputType;
}

export const Input: FunctionComponent<InputProps> = ({
    label,
    name,
    defaultValue,
    id,
    placeholder,
    register,
    validation,
    hasError,
    type = 'text',
}) => {
	let viewValue: string | number | undefined = defaultValue;

	function getType(type: InputType) {
		if (type === "currency" || type === "percentage") {
			return "text";
		}

		return type ? type : "text";
	}

	function keyDown($event: KeyboardEvent) {

		//const target: HTMLInputElement = $event.target as HTMLInputElement;

		if (type === 'currency') {
			const invalidChars = ["-", "+", "e"];
			if (invalidChars.includes($event.key)) {
				$event.preventDefault();
			}
		}

		if (type === 'percentage') {
			const validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ",", "Backspace", "Tab"];
			if (!validChars.includes($event.key)) {
				$event.preventDefault();
			}
		}
	}

	function setType($event: any, type: string | undefined, action: string) {
		if (type === "currency") {
			if (action === "blur") {
				viewValue = $event.target.value as string
			} else {
				viewValue = currencyToNumber($event.target.value as string) as number | string;
			}

			$event.target.type = action === "focus" ? "number" : "text";
			$event.target.value = action === "blur" ? (viewValue) ? "€ " + viewValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : null : viewValue;
		}

		if (type === "percentage") {
			viewValue = $event.target.value as string
			$event.target.value = action === "blur" ? (viewValue) ? `${viewValue}%` : null : viewValue.replace('%', '');
		}

	}
    return (
			<div className={`c-input ${hasError ? 'input--has-error' : ''}`}>
				{label && (
						<label className="input__label" htmlFor={id}>
								{label}
						</label>
				)}

				<input
						className="input__input"
						onFocus={e => setType(e,type, 'focus')}
						type={getType(type)}
						autoComplete={"off"}
						id={id}
						onKeyDown={keyDown}
						placeholder={placeholder}
						defaultValue={defaultValue}
						{...register(name, {...validation ? validation : {}, ...{onBlur: (event:any) => setType(event,type, 'blur')}})}
				/>
			</div>
    );
};
